import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  IconButton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import axios from "axios";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { OSType } from "models/os_type";
import { PessoaType } from "models/person_type";
import { ProductType } from "models/product_type";
import { Project, ProjectCategory } from "models/project_type";
import { useEffect, useRef, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";
import AdmItemRow from "./AdmItemRow";
import { OrderCategoryItem } from "models/order_category_item";
import { MdAdd } from "react-icons/md";

interface IAdmItemTable {
  item: ProjectCategory | undefined;
  borderColor: string;
  index: number;
  loading: boolean;
  fornecedor: PessoaType[];
  condicaoPagamento: CondicaoPagamento[];
  project: Project;
  loadOs: (item: ProjectCategory) => void;
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
  osList: OSType[];
  setOsList: React.Dispatch<React.SetStateAction<OSType[]>>;
  deleteOs: (id: string) => Promise<void>
  showContaPagarModal: boolean,
  setShowContaPagarModal: (show: boolean) => void;
}
const AdmItemTable = ({
  item,
  borderColor,
  index,
  condicaoPagamento,
  fornecedor,
  project,
  loadOs,
  showFormPessoa,
  editPessoa,
  osList,
  setOsList,
  deleteOs,
  loading,
  setShowContaPagarModal,
  showContaPagarModal
}: IAdmItemTable) => {
  const [orderList, setOrderList] = useState<OrderCategoryItem[]>([]);
  const [produtos, setProdutos] = useState<ProductType[]>([]);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const { unidades } = useMeasureUnit();
  const cancelRef = useRef(null);

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };
  const closeError = () => {
    setError(false);
  };

  const showCategTotalOrder = (item: ProjectCategory) => {
    let retorno = 0;
    if (item) {
      const rg = project?.Orcamento?.OrcamentoCategoria?.find((or) => or.descricao === item.descricao);
      if (rg) {
        retorno = rg.valor;
      }
    }

    return retorno;
  }

  const addOs = (orderParam: OrderCategoryItem) => {
    const order = project?.Orcamento?.OrcamentoCategoria.find((a) => a.descricao === item.descricao);
    const orderItem = order?.OrcamentoItem?.find((a) => a.produtoId === orderParam.produtoId);
    const projectItem = item?.ProjetoItem?.find((a) => a.produtoId === orderParam.produtoId);
    const osNum = osList.filter(item => item.produtoId === orderParam.produtoId).length + 1;
    const un = unidades.find((a) => a.id === orderParam.unidadeMedidaId);

    const osItem: OSType = {
      comercialQtd: Number(orderItem?.quantidade || 0),
      comercialTotal: Number(orderItem?.valorTotal || 0),
      comercialValorUN: Number(orderItem.valorUn || 0),
      executado: 0,
      condicaoPagamentoId: "",
      osNum: osNum,
      pago: 0,
      pessoaId: '',
      financeiroGerado: false,
      producaoQtd: Number(orderParam.quantidade || 0),
      producaoTotal: Number(orderParam.valorTotal || 0),
      producaoValorUn: Number(orderParam.valorUn || 0),
      projetoCategoriaId: item.id,
      projetoItemId: projectItem.id,
      saldo: 0,
      status: "EM ABERTO",
      trabalhoQtd: Number(orderParam.quantidade || 0),
      trabalhoTotal: Number(orderParam.valorTotal || 0),
      trabalhoValorUN: Number(orderParam.valorUn || 0),
      unidadeMedidaId: orderParam.unidadeMedidaId,
      unidadeNome: un.nome,
      tipo: 'OS',
      descricao: orderParam.descricao,
      produtoId: orderParam.produtoId,
    }

    setOsList([...osList, osItem]);
  }

  useEffect(() => {
    const loadData = async () => {
      const userData = JSON.parse(localStorage.getItem("user"));
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/produto/list/" + userData?.idEmpresa
      );
      if (response.data) {
        setProdutos(response.data);
      }
    };

    const loadItens = () => {
      if (item?.ProjetoItem?.length > 0) {
        const order = project?.Orcamento?.OrcamentoCategoria.find((a) => a.descricao === item.descricao);
        const localOrderList: OrderCategoryItem[] = [];
        item?.ProjetoItem?.map((data) => {
          const orderItem = order?.OrcamentoItem?.find((a) => a.produtoId === data.produtoId);
          localOrderList.push(orderItem);
        });

        setOrderList(localOrderList);
      }
    };

    loadItens();
    loadData();
  }, [item, item?.ProjetoItem, loadOs, project?.Orcamento?.OrcamentoCategoria]);

  return (
    <Box>
      <Table
        variant="simple"
        color="gray.500"
        mb="24px"
        mt="108px"

        key={`${index}`}
      >
        <Thead>
          <Tr>
            <Td colSpan={7}></Td>
            <Td colSpan={3} background={"blue"} color={'white'} textAlign={'center'}>
              Orçamento Comercial
            </Td>
            <Td colSpan={3} background={"green"} color={'white'} textAlign={'center'}>
              Orçamento Ref. de Trabalho
            </Td>
            <Td colSpan={3} background={"yellow"} color={'black'} textAlign={'center'}>
              Orçamento de Produção
            </Td>
            <Td colSpan={3} background={"grey"} color={'black'} textAlign={'center'}>
            </Td>
          </Tr>
          <Tr>
            <Td colSpan={7}>
              <Text
                textAlign="left"
                color={"#422AFB"}
                fontWeight={"bold"}
                fontSize={24}
                mt={-3}

              >
                {index + 1} - {item.descricao}
                {/* - subtotal :{" "}
                    {formatNumber(Number(item.valor))} */}
              </Text>
            </Td>
            <Td colSpan={3} background={"blue"} color={'white'} textAlign={'right'}>{formatNumber(Number(showCategTotalOrder(item)))}</Td>
            <Td colSpan={3} background={"green"} color={'white'} textAlign={'right'}>{formatNumber(Number(item.valor))}</Td>
            <Td colSpan={3} background={"yellow"} color={'black'} textAlign={'right'}>{formatNumber(Number(item.valor))}</Td>
            <Td background={"grey"} color={'black'} textAlign={'center'}>{formatNumber(Number(0))}</Td>
            <Td background={"grey"} color={'black'} textAlign={'center'}>{formatNumber(Number(0))}</Td>
            <Td background={"grey"} color={'black'} textAlign={'center'}>{formatNumber(Number(0))}</Td>
          </Tr>
          <Tr>
            <Th borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #AÇÕES
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OS
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ITEM
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #FORNECEDOR
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #PAGAMENTO
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #STATUS
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #UNIDADE
              </Flex>
            </Th>
            <Th borderColor={borderColor} cursor="pointer" background={"blue"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="white"
              >
                #QTD
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer" background={"blue"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="white"
              >
                #VALOR UN
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer" background={"blue"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="white"
              >
                #TOTAL
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer" background={"green"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="white"
              >
                #QTD
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer" background={"green"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="white"
              >
                #VALOR UN
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer" background={"green"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="white"
              >
                #TOTAL
              </Flex>
            </Th>

            <Th
              borderColor={borderColor}
              cursor="pointer"
              background={"yellow"}
            >
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="black"
              >
                #QTD
              </Flex>
            </Th>

            <Th
              borderColor={borderColor}
              cursor="pointer"
              background={"yellow"}
            >
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="black"
              >
                #VALOR UN
              </Flex>
            </Th>

            <Th
              borderColor={borderColor}
              cursor="pointer"
              background={"yellow"}
            >
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="black"
              >
                #TOTAL
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer" background={"grey"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="black"
              >
                #EXECUTADO
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer" background={"grey"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="black"
              >
                #PAGO
              </Flex>
            </Th>

            <Th borderColor={borderColor} cursor="pointer" background={"grey"}>
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="black"
              >
                #SALDO
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {orderList?.map((order, indexOrder) => (
            <>
              <Tr key={"__orderList-" + indexOrder} bg="blackAlpha.100">
                <Td>
                  <IconButton
                    colorScheme="brand"
                    variant="solid"
                    borderRadius={8}
                    size={'sm'}
                    icon={<MdAdd />}
                    onClick={() => addOs(order)}
                    aria-label={"Adicionar Cliente"}
                  />
                </Td>
                <Td colSpan={18}>
                  <Box alignSelf={"flex-start "}>
                    <Box w={"100%"}>
                      <Text
                        textAlign="left"
                        color={"black"}
                        fontSize={15}
                        alignSelf={"center"}
                      >
                        {order.descricao} (TOTAL ORC. {formatNumber(Number(order.valorTotal))})
                      </Text>
                    </Box>
                  </Box>
                </Td>
              </Tr>
              {osList?.filter(item => item.produtoId === order.produtoId).map((item1, index1) => (
                <AdmItemRow
                  key={"__osList-" + indexOrder + "-" + index1}
                  condicaoPagamento={condicaoPagamento}
                  fornecedor={fornecedor}
                  index={index}
                  index1={index1}
                  item1={item1}
                  produtos={produtos}
                  unidades={unidades}
                  editPessoa={editPessoa}
                  showFormPessoa={showFormPessoa}
                  order={order}
                  osList={osList}
                  setOsList={setOsList}
                  deleteOs={deleteOs}
                  loading={loading}
                />
              ))}
            </>
          ))}
        </Tbody>
      </Table>

      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};
export default AdmItemTable;
